import { baseUrl } from './api.js';
import { DomainApiError } from './api-error.js';

/**
 * Krok QAFIX2 bod 3 — klient cesty „inzeraty kancelare z akvizicniho
 * radaru". Zije vedle `office-migration-api.ts`, protoze routy jsou v jine
 * aplikaci (apps/api drzi pristup ke geo-api), ne v listing kontextu.
 *
 * Nedostupny radar NENI chyba: server vraci `available: false` a obrazovka
 * z toho dela sedy stav „ceka na pristupy" (vzor GCAL1/PORT1).
 */

export interface RadarMigrationItem {
  readonly externalId: string;
  readonly title: string;
  readonly kind: string;
  readonly addressText: string | null;
  readonly sourceUrl: string;
}

export interface RadarMigrationPreview {
  readonly available: boolean;
  readonly reason?: string;
  readonly items: readonly RadarMigrationItem[];
}

export interface RadarMigrationResult {
  readonly available: boolean;
  readonly createdCases: number;
  readonly updatedCases: number;
  readonly errors: readonly string[];
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${baseUrl}${path}`, {
    credentials: 'include',
    ...init,
    headers: { ...(init?.body !== undefined ? { 'content-type': 'application/json' } : {}) },
  });
  if (!res.ok) {
    const problem = (await res.json().catch(() => null)) as
      | { title?: string; detail?: string; type?: string }
      | null;
    const text = [problem?.title, problem?.detail]
      .filter((part): part is string => typeof part === 'string')
      .join(' ');
    throw new DomainApiError(text === '' ? `HTTP ${String(res.status)}` : text, res.status, problem?.type);
  }
  return (await res.json()) as T;
}

export async function previewRadarListings(agency: string): Promise<RadarMigrationPreview> {
  const params = new URLSearchParams({ agency: agency.trim() });
  return call<RadarMigrationPreview>(`/v1/office-migration/radar/preview?${params.toString()}`);
}

export async function importRadarListings(agency: string): Promise<RadarMigrationResult> {
  return call<RadarMigrationResult>('/v1/office-migration/radar/import', {
    method: 'POST',
    body: JSON.stringify({ agency: agency.trim() }),
  });
}
